export default "__VITE_ASSET__B_pGD6t0__"